import { OrderedParallelEnumerable } from "../OrderedParallelEnumerable.js";
export const orderDescending = (source, comparer) => {
    return OrderedParallelEnumerable.generate(source, (x) => x, false, comparer);
};
